<template>
  <v-app id="inspire" class="bodyPadding">
    <mo-header></mo-header>
    <v-content>
		<quote-head-lite></quote-head-lite>
		<!--<quote-content-lite v-if="quoteLiteContentClick == true"></quote-content-lite>-->
		<quote-list-lite></quote-list-lite>
    </v-content>
  </v-app>
</template>

<script>

  import { mapGetters } from 'vuex';
	import QuoteHeadLite from './Header.vue';
	import QuoteListLite from './List.vue';
	export default {
		data () {
			return {

			}
		},
    computed: {
      ...mapGetters([
        'objAuthorize',
        'quoteLiteContentClick',
        'quoteSingle'
      ])
    },
		components: {
      QuoteHeadLite,
      QuoteListLite
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css';
  @import '../../shared/assets/css/lite-report-style.css';
  @import '../../shared/assets/css/manu-lite-report-style.css';
</style>
